function getArticleCategoryFilters(domainId?: string, subdomainId?: string | null) {
  if (subdomainId === 'design-and-product') {
    return 'category:Design';
  }

  if (subdomainId === 'marketing') {
    return 'category:Marketing';
  }

  switch (domainId) {
    case 'business':
      return 'category:Business';
    case 'computer-science':
      return 'category:Development';
    case 'information-technology':
      return 'category:IT';
    case 'data-science':
      return 'category:Data';
    case 'life-sciences':
      return 'category:Health';
    case 'personal-development':
      return 'category:"Professional Development"';
    default:
      return undefined;
  }
}

export default getArticleCategoryFilters;
